import React from 'react';
import './activePoliciesSelect.css';
import { Select, MenuItem } from '@mui/material';
import { translations, policiesProperties } from '../../lib/consts';
type GenericObject = { [key: string]: any };

export const ActivePoliciesSelect = (data: GenericObject) => {
    return (
        <Select name={data.name} onChange={data.onChange} label={data.label} value={data.value}>
            {data.items.map((policy: GenericObject) => {
                const validFrom = new Date(policy[policiesProperties.validFrom]);
                const dateFrom = `${validFrom.getDate()}/${validFrom.getMonth() + 1}/${validFrom.getFullYear()}`;
                let dateTo = translations.POLICY_NO_END_DATE;
                if (policiesProperties.validTo && policiesProperties.validTo !== 'null') {
                    const validTo = new Date(policy[policiesProperties.validTo]);
                    dateTo = `${validTo.getDate()}/${validTo.getMonth() + 1}/${validTo.getFullYear()}`;
                }
                return (
                    <MenuItem
                        key={policy[policiesProperties.policyNumber]}
                        value={policy[policiesProperties.policyNumber]}
                        style={{ whiteSpace: 'normal' }}
                    >
                        <div>
                            <div>
                                <span style={{ fontWeight: 'bold' }}>{`${translations.POLICY_NUMBER}: `}</span>
                                {policy[policiesProperties.policyNumber]}
                            </div>
                            <div className="hide-when-selected">
                                <span style={{ fontWeight: 'bold' }}>{`${translations.INSURANCE}: `}</span>
                                {policy[policiesProperties.insurance]}
                            </div>
                            <div className="hide-when-selected">
                                <span style={{ fontWeight: 'bold' }}>{`${translations.TIME_PERIOD}: `}</span>
                                {`${dateFrom} - ${dateTo}`}
                            </div>
                            {data.showAllInfo && (
                                <div className="hide-when-selected">
                                    <span style={{ fontWeight: 'bold' }}>{`${translations.CONTRACTOR}: `}</span>
                                    {policy[policiesProperties.contractor]}
                                </div>
                            )}
                            <div className="hide-when-selected">
                                <span style={{ fontWeight: 'bold' }}>{`${translations.INSURED_PERSON}: `}</span>
                                {policy[policiesProperties.insuredPerson]}
                            </div>
                        </div>
                    </MenuItem>
                );
            })}
        </Select>
    );
};
